import { createContext, useContext } from 'react';
import ar from '@/i18n/ar.json';
import en from '@/i18n/en.json';

const DICTIONARIES = { ar, en };
export const SUPPORTED_LANGS = ['ar', 'en'];

const LanguageContext = createContext({ lang: 'ar', t: (k) => k, dict: ar });

export function LanguageProvider({ lang, children }) {
  const safeLang = SUPPORTED_LANGS.includes(lang) ? lang : 'ar';
  const data = DICTIONARIES[safeLang];

  const t = (key) => {
    if (!key) return '';
    const value = key
      .split('.')
      .reduce((obj, k) => (obj && obj[k] !== undefined ? obj[k] : undefined), data);
    if (value === undefined) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(`[i18n] Missing key "${key}" for lang "${safeLang}"`);
      }
      return key;
    }
    return value;
  };

  return (
    <LanguageContext.Provider value={{ lang: safeLang, t, dict: data }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useI18n = () => useContext(LanguageContext);
export default LanguageContext;
